export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ko": {
        "COMM_SELECT_TARGET": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["대상 선택"])}
      },
      "en": {
        "COMM_SELECT_TARGET": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select target"])}
      }
    }
  })
}
